import styled from 'styled-components';

import ActionButton from 'components/action-button';
import Picture from 'components/picture';
import { primitive } from 'styles/constants/primitives';

import { RewardLock } from '../../../reward-lock';

export const QuestCardContainer = styled.div`
  position: relative;
  height: 17.75rem;
  width: 21.4rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  overflow: hidden;
  background-color: ${Styles.color.white};
  border-radius: ${Styles.borderRadius};
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  ${Styles.desktop} {
    box-shadow: unset;
    scroll-snap-align: unset;
  }
`;

export const QuestCardPicture = styled(Picture)`
  max-height: 7.6rem;
  width: 100%;
`;

export const QuestContent = styled.div`
  display: grid;
  grid-row-gap: 0.25rem;
  padding: 1rem;
`;

export const QuestTitle = styled.h6`
  font-size: 1.375rem;
  line-height: 1.375rem;
  font-family: ${Styles.fontFamily.brand};
  color: ${Styles.color.loyaltyHighlight};
  margin: 0;
`;

export const QuestDescription = styled.p`
  font-size: 0.875rem;
  line-height: 1.125rem;
  margin: 0;
`;

export const QuestExpirationText = styled.p`
  font-size: 0.75rem;
  line-height: 1rem;
  color: ${primitive.$blackOpacity30};
  margin: 0;
`;

export const StyledButton = styled(ActionButton)`
  font-size: 0.875rem;
  line-height: 0.875rem;
  width: fit-content;
  padding: 0.25rem 0.625rem;
  border-width: 0.125rem;
  margin-block-start: 0.75rem;
  margin-block-end: 0;
  margin-inline: auto;
`;

export const RewardLockContainer = styled.div`
  position: relative;
`;

export const StyledRewardLock = styled(RewardLock)`
  transform: scale(0.5);
  padding: 2.125rem;
  background-color: ${Styles.color.loyaltyHighlight};
`;
